import axios from 'axios';
import { getKeycloak } from '../../../config/keycloak';

const rawApiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const normalisedApiUrl = (() => {
  const trimmed = rawApiUrl.replace(/\/$/, '');
  if (trimmed.endsWith('/api/v1')) return trimmed;
  if (trimmed.endsWith('/api')) return `${trimmed}/v1`;
  return `${trimmed}/api/v1`;
})();

const api = axios.create({
  baseURL: normalisedApiUrl,
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const keycloak = getKeycloak();
    if (keycloak?.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const connectorsApi = {
  // Catalogue des types supportés
  catalog: () => api.get('/connectors/catalog'),

  // Liste paginée des connecteurs configurés
  listConfigured: (params = {}) =>
    api.get('/connectors/instances', { params }),

  // Création d'un connecteur configuré
  createConfigured: (payload) =>
    api.post('/connectors/instances', payload),

  // Récupération d'un connecteur configuré
  getConfigured: (id) =>
    api.get(`/connectors/instances/${id}`),

  // Mise à jour d'un connecteur configuré
  updateConfigured: (id, payload) =>
    api.put(`/connectors/instances/${id}`, payload),

  // Suppression d'un connecteur configuré
  deleteConfigured: (id) =>
    api.delete(`/connectors/instances/${id}`),

  // Test de connexion pour un connecteur configuré
  testConfigured: (id) =>
    api.post(`/connectors/instances/${id}/test`),

  // Test d'une configuration non enregistrée
  testConfiguration: (payload) =>
    api.post('/connectors/instances/test-configuration', payload),

  // Exécution d'une action pour un connecteur configuré
  // Le backend attend ExecuteRequest = {action, payload, trace_id}.
  // On envoie le payload utilisateur dans le champ `payload` de ExecuteRequest.
  executeConfigured: (id, payload) =>
    api.post(`/connectors/instances/${id}/execute`, { payload }),
};
